import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { ReviewConflictApiDto } from "../common/dto/ReviewConflictApiDto";
import CodeSnippet from "./CodeSnippet";
import { ReviewConflictResolutionApiDto } from "../common/dto/ReviewConflictResolutionApiDto";
import { Link } from "react-router-dom";

type State = {
    conflict: ReviewConflictApiDto | undefined
}

export default class ReviewConflictPage extends Component<ServiceCollectionParam, {}> {

    state: State = {
        conflict: undefined
    }

    async componentDidMount() {
        await this.refresh();
    }

    async refresh() {
        const conflict = await this.props.services.dao.findFirstReviewConflict();

        if (!conflict) {
            return;
        }

        this.state.conflict = conflict;

        this.setState(this.state);
    }

    async resolveConflict(isPassed: boolean | null) {
        if (!this.state.conflict) {
            throw new Error();
        }

        const dto = new ReviewConflictResolutionApiDto();
        dto.tag = this.state.conflict.tag;
        dto.codeAuthor = this.state.conflict.codeAuthor;
        dto.isPassed = isPassed;

        await this.props.services.dao.resolveReviewConflict(dto);

        await this.refresh();
    }

    render() {
        if (!this.state.conflict) {
            return <div>Konflikte pole.</div>;
        }

        const conflict = this.state.conflict;

        const questions = conflict.questions.join(' ');

        return (
            <>
                <div className="d-flex justify-content-between">
                    <button onClick={ () => this.resolveConflict(false) }
                        className="btn btn-danger">Pole korras</button>
                    <button
                        onClick={ () => this.resolveConflict(null) }
                        className="btn btn-warning">Vaieldav</button>
                    <button
                        onClick={ () => this.resolveConflict(true) }
                        className="btn btn-success">Korras</button>
                </div>

                <div className="pt-3">{ conflict.codeAuthor } ({ conflict.tag })</div>

                <div className="pt-3">{ questions }</div>

                { conflict.codeSnippets.map(each =>
                    <CodeSnippet key={Math.random()} snippet={ each } />) }

                <br />

                <Link target="_blank"
                      to={'/review/' + this.state.conflict.reviewIds[0]}>Ülevaatus 1</Link>

                |

                <Link target="_blank"
                      to={'/review/' + this.state.conflict.reviewIds[1]}>Ülevaatus 2</Link>

            </>);
    }

}

